import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'di-btn-facture-preparee',
  templateUrl: './btn-facture-preparee.component.html',
  styleUrls: ['./btn-facture-preparee.component.scss'],
})
export class BtnFacturePrepareeComponent implements OnInit {

  @Input() public invoiceCount: number = 0;
  @Input() public selected: boolean = false;

  constructor() { }

  ngOnInit() { }

}
